export const COOKIE_PAGE_SIZE = 'pageSize';
export const LANDING_SESSION_COOKIE = 'landingSession';
export const PDP_FIRST_VIEW = 'pdpFirstView';
export const USER_AA_TEST_COOKIE = 'userAATest';
